import { useContext, useEffect, useState } from "react";
import ContextFlujos from "../Context/ContextFlujos";
import { Col, Container, Form, Modal, Row, Button } from "react-bootstrap";
import styles from "../BlueToGo/BlueToGo.module.css";
import { activacionBlueToGo } from "./servicios";
import { useNavigate } from "react-router-dom";

const BlueToGoActivacion = () => {
  const { setSkyPlus, setSkyCelular, setPais, setBlueToGo } = useContext(
    ContextFlujos
  ) as any;

  const navigate = useNavigate();

  const activacionBlue = async () => {
    const respuesta = await activacionBlueToGo();
    if (respuesta.result.respuesta) {
      setBlueToGo({ respuesta: true });
      navigate("/bluetogofinal");
    } else {
      setBlueToGo({ respuesta: false });
      navigate("/bluetogofinal");
    }
  };

  useEffect(() => {
    activacionBlue();
  }, []);

  return (
    <>
      <Container className={styles.containerPagina}>
        <Row>
          <Col className="pb-3 pt-3">
            <h2 className={styles["tituloPagina"]}>Activación</h2>
          </Col>

          <b className={styles["boldtext"]}>Activación en proceso</b>
          <p className={styles["parrafotext"] + " pt-3 "}>
            Estamos procesando tu solicitud cuando sea procesada te dirigiremos
            hacia la app Sky+ para que puedas disfrutar de tu programación.
          </p>
        </Row>
      </Container>
    </>
  );
};

export default BlueToGoActivacion;
